"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  var sliders = document.querySelectorAll('[data-content-slider]');
  var _iterator = _createForOfIteratorHelper(sliders),
    _step;
  try {
    var _loop = function _loop() {
      var slider = _step.value;
      var delay = parseFloat(slider.dataset.swiperAutoplay);
      var isAutoplay = !!delay;
      var swiperConfig = {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 28,
        grabCursor: true,
        keyboard: {
          enabled: true
        },
        autoplay: {
          delay: delay,
          enabled: isAutoplay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      };
      var paginationEl = slider.querySelector('.content_slider__pagination');
      var prevCtrlEl = slider.querySelector('.swiper-button-prev');
      var nextCtrlEl = slider.querySelector('.swiper-button-next');
      var slideType = slider.dataset.type;
      if (slideType === 'Scrollbar') {
        paginationEl.classList.add('swiper-scrollbar');
        swiperConfig.scrollbar = {
          el: paginationEl,
          draggable: true
        };
      }
      if (slideType === 'Pagination') {
        paginationEl.classList.add('swiper-pagination');
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true
        };
      }
      if (slideType === 'Pagination progress') {
        paginationEl.classList.add('swiper-scrollbar');
        swiperConfig.pagination = {
          el: paginationEl,
          type: 'progressbar'
        };
        swiperConfig.navigation = {
          nextEl: nextCtrlEl,
          prevEl: prevCtrlEl
        };
      }
      if (slideType === 'Carousel Slider') {
        slider.classList.add('swiper-carousel');
        paginationEl.classList.add('swiper-pagination');
        var bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        var initSlider = false;
        var changePagination = function changePagination(elSwiper) {
          var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var current = slider.querySelector('[data-swiper-slide-index="' + elSwiper.realIndex + '"]');
          current = current ? current : slider.querySelector('[data-slide-id="0"]');
          current && bullets.forEach(function (bullet) {
            bullet.classList.toggle('swiper-pagination-bullet-active', bullet.dataset.slideBulletId === current.dataset.slideId);
          });
          !isAutoplay && updateSlidesFocus(elSwiper, focus);
        };
        var changeSlide = function changeSlide(elSwiper, bullet) {
          var prevSlideId = +paginationEl.querySelector('.swiper-pagination-bullet-active').dataset.slideBulletId;
          var currentId = +bullet.dataset.slideBulletId;
          var slidesTotal = bullets.length - 1;
          // unary plus (+) operator converts its operand to a number.

          var switchDuplicate = Math.abs(currentId - prevSlideId) >= 2;
          var duplicateSlide = ".slide-duplicate[data-slide-id=\"".concat(currentId, "\"]");
          var defaultSlide = "[data-slide-id=\"".concat(currentId, "\"]:not(.slide-duplicate)");
          if (currentId === slidesTotal && prevSlideId === 0) {
            elSwiper.slidePrev();
          } else if (prevSlideId === slidesTotal && currentId === 0) {
            elSwiper.slideNext();
          } else {
            var slide = slider.querySelector(elSwiper.realIndex < slidesTotal ? switchDuplicate ? duplicateSlide : defaultSlide : switchDuplicate ? defaultSlide : duplicateSlide);
            slide && elSwiper.slideToLoop(slide.dataset.swiperSlideIndex);
          }
        };
        var updateSlidesFocus = function updateSlidesFocus(elSwiper, focus) {
          var slides = slider.querySelectorAll('.swiper-slide');
          var current = slider.querySelector('[data-swiper-slide-index="' + elSwiper.realIndex + '"]');
          current = current ? current : slider.querySelector('[data-slide-id="0"]');
          slides && slides.forEach(function (slide) {
            var item = slide.querySelector('.content_slider__item');
            item && item.setAttribute('tabindex', slide.classList.contains('swiper-slide-visible') ? '0' : '-1');
          });
          if (focus && elSwiper.realIndex !== 0 && elSwiper.previousIndex !== 0) {
            current.querySelector('.content_slider__item').focus();
          }
        };
        swiperConfig = {
          modules: [EffectCarousel],
          // pass EffectCarousel module to modules
          effect: 'carousel',
          // specify "carousel" effect
          // carousel effect parameters
          carouselEffect: {
            opacityStep: 0.33,
            // opacity change per side slide
            scaleStep: 0.15,
            // scale change per side slide
            sideSlides: 2 // amount of side slides visible, can be 1, 2 or 3
          },
          grabCursor: true,
          loop: true,
          loopAdditionalSlides: 1,
          slidesPerView: 1,
          slidesPerGroup: 1,
          breakpoints: {
            900: {
              slidesPerView: 2
            }
          },
          keyboard: {
            enabled: true
          },
          navigation: {
            nextEl: nextCtrlEl,
            prevEl: prevCtrlEl
          },
          slideToClickedSlide: false,
          autoplay: {
            delay: delay,
            enabled: isAutoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          on: {
            init: function init(e) {
              bullets && bullets.forEach(function (bullet) {
                return bullet.addEventListener('click', function () {
                  return changeSlide(e, bullet);
                });
              });
              e.slides.forEach(function (slide) {
                return slide.addEventListener('click', function () {
                  var id = slide.dataset.slideId;
                  var bullet = paginationEl.querySelector(".swiper-pagination-bullet[data-slide-bullet-id=\"".concat(id, "\"]"));
                  bullet && changeSlide(e, bullet);
                });
              });
            },
            resize: function resize(e) {
              return bullets && initSlider && changePagination(e, true);
            },
            slideChange: function slideChange(e) {
              return bullets && initSlider && changePagination(e, true);
            },
            afterInit: function afterInit(e) {
              initSlider = true;
              changePagination(e);
            }
          }
        };
      }
      if (slideType === 'Related content') {
        var BREAKPOINTS = {
          MOBILE: 375,
          TABLET: 600,
          LAPTOP: 900,
          DESKTOP: 1200
        };
        var SLIDES_PER_BREAKPOINT = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BREAKPOINTS.MOBILE, 1), BREAKPOINTS.TABLET, 2), BREAKPOINTS.LAPTOP, 3), BREAKPOINTS.DESKTOP, 4);
        var createBreakpointConfig = function createBreakpointConfig(slidesCount, breakpoint) {
          return {
            loop: slidesCount > SLIDES_PER_BREAKPOINT[breakpoint] + 1,
            slidesPerView: slidesCount > SLIDES_PER_BREAKPOINT[breakpoint] ? SLIDES_PER_BREAKPOINT[breakpoint] + 0.25 : slidesCount,
            spaceBetween: breakpoint === BREAKPOINTS.DESKTOP ? 24 : breakpoint === BREAKPOINTS.MOBILE ? 12 : 16
          };
        };
        var updateSliderAlignment = function updateSliderAlignment(swiper, slidesCount) {
          var currentBreakpoint = parseInt(Object.keys(swiper.params.breakpoints).filter(function (bp) {
            return window.innerWidth >= bp;
          }).sort(function (a, b) {
            return b - a;
          })[0]) || 0;
          swiper.slidesEl.classList.toggle("justify--center", slidesCount <= SLIDES_PER_BREAKPOINT[currentBreakpoint]);
        };
        var slidesCount = slider.querySelectorAll('.swiper-slide').length;
        swiperConfig = {
          loop: slidesCount > 1,
          loopAdditionalSlides: 1,
          slidesPerGroup: 1,
          slidesPerView: slidesCount > 1 ? 1.25 : slidesCount,
          spaceBetween: 12,
          centeredSlides: false,
          grabCursor: true,
          setWrapperSize: true,
          keyboard: {
            enabled: true
          },
          pauseOnMouseEnter: true,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev')
          },
          watchOverflow: true,
          breakpoints: Object.fromEntries(Object.values(BREAKPOINTS).map(function (bp) {
            return [bp, createBreakpointConfig(slidesCount, bp)];
          })),
          on: {
            beforeInit: function beforeInit(swiper) {
              return updateSliderAlignment(swiper, slidesCount);
            },
            resize: function resize(swiper) {
              return updateSliderAlignment(swiper, slidesCount);
            }
          },
          slideToClickedSlide: true
        };
      }
      new Swiper(slider, swiperConfig);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
})();